enum ComparisonOperator {
  EQUALS = 'EQUALS',
  BOOLEAN = 'BOOLEAN',
  LESS_THAN = 'LESS_THAN',
  IS_NULL = 'IS_NULL',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO'
}

export default ComparisonOperator;
